export default function agendaUniqueNameDirective(
  $q,
  oversightDataService
) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    const agendaId = attributes.agendaId || -1;
    let init = true;
    ngModel.$asyncValidators.agendaUniqueName = (modelValue) => {
      const defer = $q.defer();
      if (init === true) {
        init = false;
        oversightDataService.checkAgendaExists(modelValue, agendaId)
          .then((data) => {
            init = true;
            if (data && !data.data.result) {
              defer.resolve();
            } else {
              defer.reject();
            }
          })
          .catch(() => {
            init = true;
            defer.reject();
          });
      }
      return defer.promise;
    };
  }
}

export const name = 'agendaUniqueName';

agendaUniqueNameDirective.$inject = [
  '$q',
  'oversightDataService'
];
